/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Pipe, PipeTransform} from '@angular/core';
import {UserContext} from '@irian-ro/auth-shared-module';
import {distinct, take} from 'rxjs/operators';

@Pipe({
  name: 'menuItemHasAnyRights'
})
export class MenuItemHasAnyRightsPipe implements PipeTransform {

  constructor(private userContext: UserContext) {
  }

  transform(value: any, args?: any): any {
    const menuItems: any = [];

    if (value && Array.isArray(value)) {
      value.forEach((item) => {
        const menuItem = {...item}

        let isAuthorized = false;

        const authorities = menuItem.rights;

        if (!authorities || authorities.length === 0) {
          isAuthorized = true;
        } else {
          if (this.userContext.hasAnyRightsGroup(authorities)) {
            isAuthorized = true;
          }
        }
        if (menuItem.items && menuItem.items.length) {
          menuItem.items = this.transform(menuItem.items);
        }

        if ((!menuItem.items || menuItem.items.length === 0) && !menuItem.routerLink && !menuItem.url && !menuItem.command) {
          isAuthorized = false;
        }

        if (isAuthorized) {
          menuItems.push(menuItem);
        }
      });
    }

    return menuItems;

  }
}
